import {
  HttpContextToken,
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpResponse
} from '@angular/common/http';
import {catchError, map, Observable, throwError} from 'rxjs';


export const BYPASS_ERROR_HANDLING = new HttpContextToken<boolean>(() => false);

export const apiInterceptor: HttpInterceptorFn = (req, next: HttpHandlerFn) => {


  if (req.context.get(BYPASS_ERROR_HANDLING)) {
    return processResponse(next(req));
  }

  return processResponse(next(req)).pipe(
    catchError((error: HttpErrorResponse) => {

      return throwError(() => error);
    })
  );
};

const processResponse = (response$: Observable<HttpEvent<unknown>>) => {
  return response$.pipe(
    map((event: HttpEvent<unknown>) => {
      if (event instanceof HttpResponse) {
        const body = event.body as any;
        // Unwraps ApiModel structure: { success: boolean, body: T, ... }
        if (body && typeof body === 'object' && 'success' in body && 'body' in body) {
          return event.clone({body: body.success ? body.body : body});
        }
      }
      return event;
    }),
  );
};
